export const DIALOG_SIZE = {
  height: 250,
  width: 400,
};
